import { storyblokEditable } from "gatsby-source-storyblok"
import React from "react"

import GridSection from "../../../V2/Layouts/GridSection"

import PlanInfoCard from "@components/V2/Cards/Plans/Info"
import { storyblokLinkToYocoLink } from "@utils/storyblok"

const StoryblokPlanGridSection = ({
  blok,
}: Storyblok.BlokProps<Storyblok.PlanGridSection>) => {
  const plans = blok.plans ?? []

  const blokHeading = blok.heading?.[0]

  // Every plan shares the same shared CSS-subgrid row tracks:
  //   (banner?) + header + cta + featuresTitle + features + transactionFee
  const reserveBannerTrack = plans.some((plan) => plan.showBanner)
  const subgridTrackCount = (reserveBannerTrack ? 1 : 0) + 2 + 2 + 1

  return (
    <GridSection
      id={blok.id}
      heading={{
        size: blokHeading?.size || "large",
        alignment: blokHeading?.alignment,
        mobileAlignment: blokHeading?.mobileAlignment,
        superscriptText: blokHeading?.superscriptText,
        superscriptColor: blokHeading?.superscriptColor,
        headingText: blokHeading?.headingText,
        headingTextColor: blokHeading?.headingTextColor,
        headingBodyText: blokHeading?.headingBodyText,
        headingBodyColor: blokHeading?.headingBodyColor,
        highlightedText: blokHeading?.highlightedText,
        highlightColor: blokHeading?.highlightColor,
        callout: blokHeading?.callout?.[0],
        calloutPosition: blokHeading?.calloutPosition,
      }}
      primaryBackgroundColor={blok.primaryBackgroundColor}
      secondaryBackgroundColor={blok.secondaryBackgroundColor}
      tertiaryBackgroundColor={blok.tertiaryBackgroundColor}
      gradientDirection={blok.gradientDirection}
      rounded={blok.isRounded}
      // @ts-expect-error to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    >
      {plans.map((plan) => (
        <PlanInfoCard
          key={plan._uid}
          plan={plan.plan.content}
          featuresTitle={plan.featuresTitle}
          features={plan.features}
          primaryBackgroundColor={plan.primaryBackgroundColor}
          secondaryBackgroundColor={plan.secondaryBackgroundColor}
          borderColor={plan.borderColor}
          bannerText={plan.bannerText}
          showBanner={plan.showBanner}
          ctaType={plan.ctaType}
          ctaText={plan.ctaText}
          ctaLink={storyblokLinkToYocoLink(plan.ctaLink)}
          ctaColor={plan.ctaColor}
          subgridTrackCount={subgridTrackCount}
          reserveBannerTrack={reserveBannerTrack}
          // @ts-expect-error to have more strict typing compared to Storybloks generic object typing
          {...storyblokEditable(plan)}
        />
      ))}
    </GridSection>
  )
}

export default StoryblokPlanGridSection
